import { reactive } from 'vue';
import request from '@/utils/request';

// 站点公共联系方式：默认值为兜底，后台参数管理配置后自动覆盖
// 参数键：website.contact.phone / website.contact.email / website.contact.address
export const siteConfig = reactive({
  phone: '4000-567-200',
  email: 'yngy12023@163.com',
  address: '云南省昆明市官渡区顺通大道31号1栋10层',
});

let loaded = false;

export function loadSiteConfig() {
  if (loaded) return;
  loaded = true;
  request({
    url: '/profile/site/config',
    method: 'get',
  }).then((res) => {
    const d = res && res.data;
    if (d && typeof d === 'object') {
      if (d.phone) siteConfig.phone = d.phone;
      if (d.email) siteConfig.email = d.email;
      if (d.address) siteConfig.address = d.address;
    }
  }).catch(() => {});
}
